import he from 'he';

const sanitizeHtml = string => {
  if (!string) return '';
  const withoutTags = string.replaceAll(/<[^>]+>/g, '');
  return he.decode(withoutTags);
};

const stripFromTags = string => string.replaceAll(/<[^>]+>/g, '');

export { sanitizeHtml, stripFromTags };
